import config from 'config';
import clientId from 'clientId';
import request from 'superagent';

export default ({
  email,
  password,
  type,
}) => {

  return request.post(config.eadmin.baseUrl + '/oauth/signin')
    .send({
      type,
      email,
      password,
      client_id: clientId,
    })
    .endAsync()
    .then((res) => {
      localStorage.access_token = res.body.access_token;
    });
};



/** WEBPACK FOOTER **
 ** ./src/app/helpers/signInAsync.js
 **/